import type { ZodTypeAny } from 'zod';
import { z } from 'zod';

import type { FieldDescriptor } from '../../types/common';

import { EditModalFieldElement } from './EditModalField';
import type { EditModalField as EditModalFieldType } from './types';

const createValidationSchema = (field: EditModalFieldType) => {
  let fieldSchema: ZodTypeAny = z.union([z.string(), z.number(), z.boolean()], {
    required_error: 'Please select an option',
  });
  if (field.validation?.isOptional) {
    fieldSchema = fieldSchema.optional();
  }

  return fieldSchema;
};

const Descriptor: FieldDescriptor<EditModalFieldType> = {
  FieldComponent: EditModalFieldElement,
  name: 'EditModalField',
  createValidationSchema,
};

export default Descriptor;
